import CustomButton from 'components/CustomInput/Button';
import React, { useState, useEffect } from 'react';
import LoadingIndicator from 'components/LoadingIndicator';
import TextHeader from 'components/CustomText/TextHeader';
import { Checkbox, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomTextField from 'components/Input/CustomTextField';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import CustomTable from 'components/CustomTable';
import PopupInput from 'components/Application/TeamMemberForm/PopupInput';
import SubjectOutcome from './SubjectOutcome';
import SeriousAdverseEvents from './SeriousAdverseEvents';
import RemedialActions from './RemedialActions';
import useUploadDocData from './useUploadDocData';
import GeneralPostApprovalLayout from 'components/GeneralPostApprovalLayout';
import CustomRadio from 'components/CustomRadio';
import { postApprovalPermissionChecking, getTimeWithTimeZone } from 'utility/general';
import { SEvenRow } from 'style/CommonStyledComponent';
import useQuery from 'hooks/useQuery';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useHistory } from 'react-router';
import useDialog from 'components/ConfirmDialog/useDialog';
import { LOCAL_SAE_REPORT } from 'utility/postApprovalLookUp';
import { SAVE_LOCAL_SAE, GET_LOCAL_SAE, SUBMIT_LOCAL_SAE, SET_LOCAL_SAE_REPORT } from 'store/key';
import { GENERAL_SAVE_SUCCESS, GENERAL_SUBMIT_SUCCESS, ERROR_MAX_LENGTH } from 'utility/frontendMessage';

const useStyles = makeStyles((theme) => ({
    page: {
        padding: 15,
    },
    itemContent: {
        paddingTop: 20,
    },
    subItem: {
        paddingTop: 10,
    },
    textSubHeader: {
        paddingBottom: 10,
    },
    leftColumn: {
        paddingRight: 30,
    },
    rightColumn: {
        paddingLeft: 30,
    },
    italicText: {
        paddingTop: 5,
        fontStyle: 'italic',
    },
}));

const SAEReport = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const showDialog = useDialog();
    let appId = useQuery('appId');
    if (appId) {
        appId = Number(appId);
    }
    const reportId = useQuery('reportId');
    const siteId = useQuery('siteId');
    const location = useLocation();
    const history = useHistory();
    const systemMsg = useSelector((state) => state.systemMessage.systemMessage);

    const localSAEReport = useSelector((state) => state.localSAEReport);
    const rows = localSAEReport.rows;
    const remoteDetail = localSAEReport.remoteDetail;
    const hasCCOAction = remoteDetail.hasCCOAction;
    const status = remoteDetail.lastStatus;
    const isLoading = localSAEReport.isLoading;
    const approvalDecisionDate = localSAEReport.remoteDetail.decisionDate;
    const forceErrorDisplay = localSAEReport.forceErrorDisplay;

    const isPermission = postApprovalPermissionChecking({ status, reportData: localSAEReport.remoteDetail });
    let isViewOnly = !isPermission;

    const isFormCreate = !reportId;
    const docType = LOCAL_SAE_REPORT;

    const signedFileId = localSAEReport.remoteDetail.signedFileId;
    const signedFileName = localSAEReport.remoteDetail.signedFileName;
    const [signedUpload, setSignedUpload] = useState({ fileName: '', key: null });

    useEffect(() => {
        if (signedFileId || signedFileName) {
            setSignedUpload({ fileName: signedFileName, key: signedFileId });
        } else {
            setSignedUpload({ fileName: '', key: null });
        }
    }, [signedFileId, signedFileName]);

    const [actualStudyStartDateValid, setActualStudyStartDateValid] = useState(true);
    const [recruitedSubjectNoValid, setRecruitedSubjectNoValid] = useState(true);
    const [nameOfStudySiteValid, setNameOfStudySiteValid] = useState(true);
    const [causeOfDeathValid, setCauseOfDeathValid] = useState(true);
    const [subjectRefCodeValid, setSubjectRefCodeValid] = useState(true);
    const [subjectRefInitialsValid, setSubjectRefInitialsValid] = useState(true);
    const [subjectRefAgeValid, setSubjectRefAgeValid] = useState(true);
    const [subjectRefSexValid, setSubjectRefSexValid] = useState(true);
    const [relevantMedicalHistoryValid, setRelevantMedicalHistoryValid] = useState(true);
    const [natureOfSaeValid, setNatureOfSaeValid] = useState(true);
    const [saeStartDateValid, setSaeStartDateValid] = useState(true);
    const [saeStopDateValid, setSaeStopDateValid] = useState(true);
    const [affectedSubjectValid, setAffectedSubjectValid] = useState(true);
    const [alterationRequiredValid, setAlterationRequiredValid] = useState(true);
    const [recommendationValid, setRecommendationValid] = useState(true);
    const [suspectedRelationshipValid, setSuspectedRelationshipValid] = useState(true);
    const [typeOfSaeValid, setTypeOfSaeValid] = useState(true);
    const [frequencyValid, setFrequencyValid] = useState(true);

    const {
        columns: uploadDocColumns,
        defaultUploadDocFormList,
        onUploadDocEditSubmit,
        handleUploadDocUpdate,
        handleUploadDocDelete,
        showUploadDocDialog,
        setShowUploadDocDialog,
    } = useUploadDocData({ localSAEReport, rows });

    const checkIsFormDataChanged = () => {
        if (localSAEReport.remoteDetail.addSupplements.length || localSAEReport.remoteDetail.deleteSupplements.length) {
            return true;
        }

        let isChanged = false;
        for (let key in localSAEReport.oldData) {
            if (['actualStudyStartDate', 'saeStartDate', 'saeStopDate'].includes(key)) {
                if (
                    new Date(localSAEReport.oldData[key]).getTime() !==
                    new Date(localSAEReport.remoteDetail[key]).getTime()
                ) {
                    isChanged = true;
                    break;
                }
            } else if (localSAEReport.oldData[key] !== localSAEReport.remoteDetail[key]) {
                isChanged = true;
                break;
            }
        }

        return isChanged;
    };

    const getSusarDetail = () => {
        dispatch({
            type: GET_LOCAL_SAE,
            payload: {
                docType,
                reportId,
                appId,
                isFormCreate,
                siteId,
                onPermissionError: () => {
                    history.push('/');
                },
            },
        });
    };

    useEffect(() => {
        getSusarDetail();
        // eslint-disable-next-line
    }, [reportId]);

    const handleFormCreate = ({ callback }) => {
        const { pathname } = location;
        dispatch({
            type: SAVE_LOCAL_SAE,
            payload: {
                siteId,
                reportId,
                appId,
                isFormCreate,
                signedFileId: signedUpload.key,
                callback: (newReportId) => {
                    showDialog({
                        description: GENERAL_SAVE_SUCCESS,
                        disableCancelButton: true,
                    });

                    if (isFormCreate) {
                        callback?.(newReportId);
                        history.push(`${pathname}?reportId=${newReportId}`);
                    } else {
                        getSusarDetail();
                        callback?.();
                    }
                },
            },
        });
    };

    const checkSeriousnessValid = () => {
        let valid =
            [
                remoteDetail.isDeath,
                remoteDetail.isLiftThreatening,
                remoteDetail.isSignificantDisability,
                remoteDetail.isRequiredHospitalization,
                remoteDetail.isPersisentDisability,
                remoteDetail.isProlongedHospitalization,
                remoteDetail.isCongenitalAnomaly,
                remoteDetail.isNone,
                remoteDetail.isOther,
            ].filter((item) => item !== null && item !== false).length > 0;
        return valid;
    };

    const checkSubmitFormValid = () => {
        dispatch({
            type: SET_LOCAL_SAE_REPORT,
            payload: {
                forceErrorDisplay: true,
            },
        });

        let valid = true;
        if (!checkSeriousnessValid()) {
            valid = false;
        }

        if (
            [
                actualStudyStartDateValid,
                recruitedSubjectNoValid,
                nameOfStudySiteValid,
                causeOfDeathValid,
                subjectRefCodeValid,
                subjectRefInitialsValid,
                subjectRefAgeValid,
                subjectRefSexValid,
                relevantMedicalHistoryValid,
                natureOfSaeValid,
                saeStartDateValid,
                saeStopDateValid,
                affectedSubjectValid,
                alterationRequiredValid,
                recommendationValid,
                suspectedRelationshipValid,
                typeOfSaeValid,
                frequencyValid,
            ].includes(false)
        ) {
            valid = false;
        }

        if ([remoteDetail.subjectOutcome].includes(null)) {
            valid = false;
        }

        return {
            valid: valid,
        };
    };

    const checkSaveFormValid = () => {
        let valid = true;
        if (!['', null].includes(remoteDetail.nameOfStudySite) && !nameOfStudySiteValid) {
            valid = false;
        }

        if (!['', null].includes(remoteDetail.causeOfDeath) && !causeOfDeathValid) {
            valid = false;
        }
        if (!['', null].includes(remoteDetail.subjectRefCode) && !subjectRefCodeValid) {
            valid = false;
        }
        if (!['', null].includes(remoteDetail.subjectRefInitials) && !subjectRefInitialsValid) {
            valid = false;
        }
        if (!['', null].includes(remoteDetail.subjectRefAge) && !subjectRefAgeValid) {
            valid = false;
        }
        if (!['', null].includes(remoteDetail.relevantMedicalHistory) && !relevantMedicalHistoryValid) {
            valid = false;
        }
        if (!['', null].includes(remoteDetail.natureOfSae) && !natureOfSaeValid) {
            valid = false;
        }

        return {
            valid: valid,
            msg: ERROR_MAX_LENGTH,
        };
    };

    const onSubmit = async () => {
        dispatch({
            type: SUBMIT_LOCAL_SAE,
            payload: {
                siteId,
                reportId,
                appId,
                isFormCreate,
                signedFileId: signedUpload.key,
                callback: () => {
                    showDialog({
                        description: GENERAL_SUBMIT_SUCCESS,
                        disableCancelButton: true,
                    });
                    history.push('/');
                },
            },
        });
    };

    const changeNotYetStarted = (e) => {
        const value = e.target.checked ? true : null;
        if (value) {
            dispatch({
                type: SET_LOCAL_SAE_REPORT,
                payload: {
                    remoteDetail: {
                        ...remoteDetail,
                        actualStudyStartDate: null,
                        isNotYetStarted: value,
                    },
                },
            });
        } else {
            updateRemoteDetail('isNotYetStarted', value);
        }
    };

    const updateRemoteDetail = (key, value) => {
        dispatch({
            type: SET_LOCAL_SAE_REPORT,
            payload: {
                remoteDetail: {
                    ...remoteDetail,
                    [key]: value,
                },
            },
        });
    };

    return (
        <GeneralPostApprovalLayout
            type={docType}
            isFormCreate={isFormCreate}
            onCreate={handleFormCreate}
            onSubmit={onSubmit}
            isLoading={isLoading}
            isViewOnly={isViewOnly}
            status={status}
            reportId={reportId}
            hasCCOAction={hasCCOAction}
            isPermission={isPermission}
            signedUpload={signedUpload} // case 1: object from server, case 2: object from local upload
            onSignedDocumentUploaded={(result) => {
                // result is in format {fileName: 'test.docx', key: 112, isNewUpload: true }
                // isNewUpload indicate the file is uploaded but not saved in form.
                setSignedUpload(result);
            }}
            checkIsFormDataChanged={checkIsFormDataChanged}
            checkSubmitFormValid={checkSubmitFormValid}
            checkSaveFormValid={checkSaveFormValid}
            siteInfo={remoteDetail?.siteInstruction}
        >
            {showUploadDocDialog && (
                <PopupInput
                    title={'Upload Supplementary Document'}
                    height="500px"
                    width="700px"
                    alignItems={'center'}
                    defaultFormList={defaultUploadDocFormList}
                    editRow={onUploadDocEditSubmit}
                    setOpenPopup={setShowUploadDocDialog}
                    tableList={rows}
                    onSubmit={handleUploadDocUpdate}
                    isUpload={true}
                />
            )}
            {isLoading ? (
                <div
                    style={{
                        height: 300,
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        justifyContent: 'center',
                    }}
                >
                    <LoadingIndicator />
                </div>
            ) : (
                <>
                    <Grid>
                        <TextHeader style={{ textAlign: 'center', marginBottom: 10 }}>
                            Local Serious Adverse Event (SAE) Report Form
                        </TextHeader>
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader className={classes.textSubHeader}>1. Basic Information</TextSubHeader>

                        <SEvenRow style={{ marginTop: 10 }}>
                            <div>
                                <div>Scientific Title:</div>
                                <div style={{ wordBreak: 'break-word' }}>{remoteDetail.scientificTitle}</div>
                            </div>
                        </SEvenRow>
                        <SEvenRow style={{ marginTop: 20 }}>
                            <div>
                                <div>IRB/REC Ref. No.:</div>
                                <div style={{ wordBreak: 'break-word' }}>{remoteDetail.refNo}</div>
                            </div>
                            <div>
                                <div>Coordinating Investigator:</div>
                                <div style={{ wordBreak: 'break-word' }}>{remoteDetail.ci}</div>
                            </div>
                        </SEvenRow>
                        <SEvenRow style={{ marginTop: 20 }}>
                            <div>
                                <div>Protocol No.:</div>
                                <div style={{ wordBreak: 'break-word' }}>{remoteDetail.protocolNo}</div>
                            </div>
                            <div>
                                <div>Site Principal Investigator of this SAE site:</div>
                                <div style={{ wordBreak: 'break-word' }}>{remoteDetail.piSiteName}</div>
                            </div>
                        </SEvenRow>

                        <SEvenRow style={{ marginTop: 20 }}>
                            <div>
                                <div>Actual Study Start Date:</div>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: 150 }}>
                                        <CustomDatePicker
                                            onChange={(date) => {
                                                updateRemoteDetail('actualStudyStartDate', date);
                                            }}
                                            value={remoteDetail?.actualStudyStartDate}
                                            disabled={isViewOnly || remoteDetail.isNotYetStarted}
                                            minDate={new Date(approvalDecisionDate).getTime()}
                                            maxDate={new Date().getTime()}
                                            validators={remoteDetail.isNotYetStarted ? [] : ['isRequired']}
                                            forceErrorDisplay={forceErrorDisplay}
                                            isValidValue={(isValid) => setActualStudyStartDateValid(isValid)}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            marginLeft: 10,
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Checkbox
                                            disabled={isViewOnly}
                                            checked={remoteDetail ? remoteDetail.isNotYetStarted : null}
                                            onChange={changeNotYetStarted}
                                            size="small"
                                            color="primary"
                                        />
                                        Not yet started
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>Anticipated Study End Date:</div>
                                <div>
                                    {getTimeWithTimeZone(remoteDetail.antipicateStudyEndDate).format('YYYY-MM-DD')}
                                </div>
                            </div>
                        </SEvenRow>

                        <SEvenRow style={{ marginTop: 20 }}>
                            <div>
                                <div>Planned Sample Size (site):</div>
                                <div style={{ wordBreak: 'break-word' }}>{remoteDetail.plannedSampleSize}</div>
                            </div>
                        </SEvenRow>

                        <SEvenRow style={{ marginTop: 20 }}>
                            <div>
                                <div>Actual no. of recruited subjects (site):</div>
                                <div>
                                    <CustomTextField
                                        disabled={isViewOnly}
                                        label="Actual no. of recruited subjects (site)"
                                        value={remoteDetail.recruitedSubjectNo}
                                        forceErrorDisplay={forceErrorDisplay}
                                        validators={['isRequired']}
                                        numberField
                                        minNumber={0}
                                        isValidValue={(isValid) => setRecruitedSubjectNoValid(isValid)}
                                        onChange={(e) => {
                                            updateRemoteDetail('recruitedSubjectNo', Number(e.target.value));
                                        }}
                                    />
                                </div>
                            </div>
                        </SEvenRow>
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader>2. Study Site(s) Involved</TextSubHeader>

                        <SEvenRow style={{ marginTop: 20 }}>
                            <div>
                                <div>Name of study site:</div>
                                <div>
                                    <CustomTextField
                                        disabled={isViewOnly}
                                        label="Name of study site:"
                                        value={remoteDetail.nameOfStudySite}
                                        forceErrorDisplay={forceErrorDisplay}
                                        validators={['isRequired']}
                                        maxLength={255}
                                        isValidValue={(isValid) => setNameOfStudySiteValid(isValid)}
                                        onChange={(e) => {
                                            updateRemoteDetail('nameOfStudySite', e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </SEvenRow>
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader style={{}}>
                            3. Subject Outcome at Time of Report
                            {forceErrorDisplay && remoteDetail.subjectOutcome === null && (
                                <div style={{ color: 'red', fontSize: 12, fontWeight: 'normal', marginTop: 10 }}>
                                    {systemMsg.required}
                                </div>
                            )}
                        </TextSubHeader>
                        <SubjectOutcome
                            classes={classes}
                            remoteDetail={remoteDetail}
                            updateRemoteDetail={updateRemoteDetail}
                            isViewOnly={isViewOnly}
                            forceErrorDisplay={forceErrorDisplay}
                            setCauseOfDeathValid={setCauseOfDeathValid}
                            dispatch={dispatch}
                        />
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader>4. Serious Adverse Events</TextSubHeader>
                        <SeriousAdverseEvents
                            classes={classes}
                            remoteDetail={remoteDetail}
                            updateRemoteDetail={updateRemoteDetail}
                            isViewOnly={isViewOnly}
                            dispatch={dispatch}
                            forceErrorDisplay={forceErrorDisplay}
                            setSubjectRefCodeValid={setSubjectRefCodeValid}
                            setSubjectRefInitialsValid={setSubjectRefInitialsValid}
                            setSubjectRefAgeValid={setSubjectRefAgeValid}
                            setSubjectRefSexValid={setSubjectRefSexValid}
                            setRelevantMedicalHistoryValid={setRelevantMedicalHistoryValid}
                            setNatureOfSaeValid={setNatureOfSaeValid}
                            setSaeStartDateValid={setSaeStartDateValid}
                            setSaeStopDateValid={setSaeStopDateValid}
                            checkSeriousnessValid={checkSeriousnessValid}
                            systemMsg={systemMsg}
                            setTypeOfSaeValid={setTypeOfSaeValid}
                            setFrequencyValid={setFrequencyValid}
                        />
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader>5. Suspected Relationship to Study</TextSubHeader>
                        <Grid container className={classes.subItem}>
                            <Grid container alignItems="center">
                                <CustomRadio
                                    isRequired
                                    forceErrorDisplay={forceErrorDisplay}
                                    isValidValue={(isValid) => setSuspectedRelationshipValid(isValid)}
                                    disabled={isViewOnly}
                                    onChange={(e) => {
                                        updateRemoteDetail('suspectedRelationship', Number(e.target.value));
                                    }}
                                    value={
                                        remoteDetail.suspectedRelationship !== null
                                            ? Number(remoteDetail.suspectedRelationship)
                                            : null
                                    }
                                    operators={[
                                        {
                                            key: 0,
                                            label: 'Definite',
                                            value: false,
                                        },
                                        {
                                            key: 1,
                                            label: 'Probable',
                                            value: false,
                                        },
                                        {
                                            key: 2,
                                            label: 'Possible',
                                            value: false,
                                        },
                                        {
                                            key: 3,
                                            label: 'Not related',
                                            value: false,
                                        },
                                        {
                                            key: 4,
                                            label: 'Not assessable',
                                            value: false,
                                        },
                                    ]}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader>6. Remedial Actions</TextSubHeader>
                        <RemedialActions
                            classes={classes}
                            remoteDetail={remoteDetail}
                            updateRemoteDetail={updateRemoteDetail}
                            isViewOnly={isViewOnly}
                            forceErrorDisplay={forceErrorDisplay}
                            setAffectedSubjectValid={setAffectedSubjectValid}
                            setAlterationRequiredValid={setAlterationRequiredValid}
                            setRecommendationValid={setRecommendationValid}
                        />
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader>Upload Supplementary Document</TextSubHeader>
                        {isPermission && (
                            <CustomButton
                                disabled={isViewOnly}
                                style={{ marginTop: 8 }}
                                onClick={() => setShowUploadDocDialog(true)}
                            >
                                Add
                            </CustomButton>
                        )}
                        <Grid className={classes.subItem}>
                            <CustomTable
                                disabled={isViewOnly}
                                columns={uploadDocColumns}
                                rows={rows}
                                isDeleteAllow={!isViewOnly}
                                onDelete={handleUploadDocDelete}
                            />
                        </Grid>
                    </Grid>
                </>
            )}
        </GeneralPostApprovalLayout>
    );
};

export default SAEReport;
